<script setup>
/* eslint-disable */
import { useCurrenciesStore } from '@/stores/currencies';
import { closeModal, openModal } from '@kolirt/vue-modal'
import commonSvgs from '@/assets/svgs/commonSvgs.json';
import { useMissionsStore } from '@/stores/missions';
import MissionsSidebar from './MissionsSidebar.vue';
import { computed } from 'vue';

const currencyStore = useCurrenciesStore();
const missionsStore = useMissionsStore();

const svg_data = commonSvgs;

const props = defineProps({
	mission: {
		type: Object,
		required: true,
	},
});
const selectMission = (mission_id) => {
	missionsStore.setSelectedMission(mission_id);
	closeModal();
	setTimeout(() => {
		openModal(MissionsSidebar).then((data) => {}).catch(() =>{});
	}, 500);
}

const displayRewards = computed(() => {
	const rewards = [];

	const freebet_dynamic = props.mission.freebet_type === 'dynamic';
	const freespin_dynamic = props.mission.freespin_type === 'dynamic';
	const freebet_amount = props.mission.rewards?.freebet_amount;
	const freespin_quantity = props.mission.rewards?.freespin_quantity;

	if (freebet_dynamic) {
		rewards.push({
			type: 'freebet',
			dynamic: true,
		});
	} else if (freebet_amount) {
		rewards.push({
			type: 'freebet',
			amount: freebet_amount,
		});
	}

	if (freespin_dynamic) {
		rewards.push({
			type: 'freespin',
			dynamic: true,
		});
	} else if (freespin_quantity) {
		rewards.push({
			type: 'freespin',
			amount: freespin_quantity,
		});
	}

	return rewards;
});

</script>
<template>
	<div class="background">
		<div class="title">
			<svg class="normal-img"
				xmlns="http://www.w3.org/2000/svg"
				xml:space="preserve"
				version="1.1"
				style="width:23px; fill: none; stroke: var(--banner-text-color); shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
				viewBox="0 0 30 25"
				xmlns:xlink="http://www.w3.org/1999/xlink">
				<use :xlink:href="'/assets/white_sport_icons/Archery.svg#svg3108'" stroke-width="1px"  />
			</svg>
			<h6>{{ $t('missions.missions') }}</h6>
			<a @click="closeModal" style="cursor: pointer;">
				<object v-html="svg_data.form_cross_white"></object>
			</a>
		</div>
		<div class="title_container">
			<h6>{{ props.mission.name }}</h6>
		</div>

		<div class="subtitle_container">
			<h6 v-if="props.mission.mission_type === 'both'"> {{ $t('missions.complete_and_rewards') }}</h6>
			<h6 v-else> {{ $t('missions.complete_and_reward') }}</h6>
		</div>

		<div class="item_container" v-if="displayRewards.length">
			<div class="item" style="text-align: center;">
				<div style="display: flex; align-items: center; justify-content: center; gap: 30px;">
					<div v-for="(reward, index) in displayRewards" :key="index" style="text-align: center;">
						<svg v-if="reward.type === 'freebet'"  xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
								style="width: 60px; height: 65px; fill: var(--banner-text-color);; stroke: var(--banner-text-color);;
								shape-rendering:geometricPrecision; text-rendering:geometricPrecision;
								image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
								viewBox="0 0 34 34" xmlns:xlink="http://www.w3.org/1999/xlink">
								<use :xlink:href="'/assets/images/receipt.svg' + '#svg3108'" />
							</svg>

							<svg  v-if="reward.type === 'freespin'" class="slot_img" xmlns="http://www.w3.org/2000/svg" version="1.0" width="70px" height="65px" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">
								<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="var(--banner-text-color);" stroke="none">
									<path d="M1094 5101 c-195 -56 -324 -236 -324 -451 l0 -60 -48 0 c-163 0 -349 -115 -429 -266 -64 -120 -63 -114 -63 -708 0 -425 3 -552 14 -592 22 -83 76 -174 144 -241 l62 -62 0 -1003 -1 -1003 -61 -35 c-74 -43 -150 -125 -188 -205 -75 -159 -64 -302 29 -395 76 -76 99 -80 416 -80 260 0 273 1 299 21 19 15 26 30 26 54 0 24 -7 39 -26 54 -25 20 -39 21 -291 21 -292 0 -309 3 -339 62 -32 62 0 187 70 273 19 23 63 57 98 76 l63 34 1472 3 c1466 2 1472 2 1527 -18 30 -12 78 -42 106 -67 69 -62 102 -129 108 -219 4 -68 3 -72 -26 -105 l-30 -34 -1239 -5 c-805 -3 -1244 -9 -1255 -15 -42 -25 -39 -101 5 -124 17 -9 333 -11 1267 -9 l1245 3 41 22 c97 52 146 133 145 244 0 170 -87 320 -239 414 l-62 38 0 278 0 279 53 0 c144 0 292 83 351 199 l16 30 218 3 218 3 65 32 c79 39 140 102 177 181 l27 57 3 606 2 606 26 14 c42 22 130 124 158 183 129 272 -38 587 -339 639 -187 32 -384 -72 -472 -250 -32 -65 -37 -86 -41 -164 -3 -51 1 -109 8 -136 25 -100 86 -194 165 -253 l45 -34 0 -408 0 -408 -129 0 -129 0 -25 43 c-61 104 -184 175 -317 184 l-80 6 0 153 0 153 56 53 c71 67 108 120 142 205 l27 68 3 536 c3 455 1 547 -12 603 -52 224 -235 384 -461 405 l-70 6 -6 95 c-7 108 -23 158 -75 236 -61 91 -162 159 -272 183 -37 8 -314 11 -920 10 -796 0 -872 -2 -928 -18z m1877 -159 c108 -53 161 -136 167 -264 l4 -88 -335 0 -336 0 -20 -26 c-26 -33 -27 -65 -2 -95 l19 -24 474 -5 473 -5 67 -33 c78 -38 138 -100 177 -182 l26 -55 0 -550 0 -550 -27 -57 c-35 -76 -95 -138 -170 -179 l-63 -34 -1390 0 -1390 0 -57 28 c-74 36 -139 101 -175 175 l-28 57 0 560 c0 555 0 560 22 608 31 66 115 152 182 184 l56 28 765 5 c421 3 772 9 781 13 17 8 39 49 39 71 0 7 -9 25 -21 40 l-20 26 -635 0 -634 0 0 58 c0 147 77 261 207 308 31 11 195 13 918 11 l880 -2 46 -23z m1671 -1280 c58 -25 118 -85 149 -148 32 -66 33 -177 3 -245 -89 -194 -341 -241 -486 -92 -25 27 -54 64 -64 83 -25 51 -30 165 -10 228 29 88 118 169 211 193 48 13 147 3 197 -19z m-52 -1280 l0 -559 -23 -44 c-22 -40 -96 -109 -118 -109 -5 0 -9 254 -9 635 l0 635 75 0 75 0 0 -558z m-1130 -684 l0 -948 -150 0 -150 0 0 128 c0 78 -6 152 -15 191 -37 156 -155 305 -295 373 -133 64 -120 63 -825 63 -633 0 -641 0 -710 -22 -189 -60 -332 -205 -389 -393 -11 -34 -19 -110 -23 -198 l-6 -142 -149 0 -148 0 0 948 0 947 1430 0 1430 0 0 -947z m337 526 c61 -38 100 -95 113 -163 5 -29 10 -127 10 -216 0 -89 -5 -187 -10 -216 -21 -113 -108 -188 -230 -197 l-70 -5 0 418 0 418 70 -5 c55 -4 81 -12 117 -34z m493 -379 l0 -185 -110 0 -110 0 0 185 0 185 110 0 110 0 0 -185z m-1648 -494 c166 -22 299 -132 349 -290 14 -48 19 -92 19 -187 l0 -124 -977 2 -978 3 -3 85 c-6 180 31 294 127 391 64 64 146 106 229 118 76 11 1149 13 1234 2z" fill="var(--banner-text-color)"/>
									<path d="M841 4204 c-30 -8 -69 -23 -87 -34 -46 -29 -102 -94 -127 -148 -21 -46 -22 -58 -22 -407 l0 -360 28 -56 c32 -66 99 -132 165 -162 l47 -22 1159 -3 c1276 -3 1230 -5 1321 58 55 38 91 84 116 150 17 46 19 79 19 395 0 323 -1 348 -21 399 -26 70 -92 139 -167 174 l-57 27 -1160 2 c-993 2 -1168 0 -1214 -13z m664 -589 l0 -450 -295 -3 c-185 -2 -308 1 -331 8 -51 14 -88 47 -110 94 -17 37 -19 71 -19 351 0 280 2 314 19 350 10 22 28 48 39 58 47 43 82 46 397 44 l300 -2 0 -450z m905 0 l0 -455 -375 0 -375 0 0 455 0 455 375 0 375 0 0 -455z m773 444 c50 -12 78 -34 106 -80 20 -33 21 -48 21 -362 0 -306 -1 -330 -20 -366 -11 -22 -36 -50 -57 -62 -38 -24 -42 -24 -355 -27 l-318 -3 0 455 0 456 291 0 c173 0 307 -4 332 -11z" fill="var(--banner-text-color)"/>
									<path d="M964 3913 c-53 -11 -75 -83 -39 -123 16 -18 31 -20 122 -20 63 0 103 -4 103 -10 0 -6 -38 -87 -85 -180 -47 -93 -85 -179 -85 -191 0 -54 52 -89 102 -68 24 10 48 50 148 250 128 254 139 289 99 325 -19 17 -39 19 -183 21 -88 0 -171 -1 -182 -4z" fill="var(--banner-text-color)"/>
									<path d="M1854 3906 c-48 -22 -60 -80 -24 -116 17 -17 33 -20 125 -20 58 0 105 -2 105 -5 0 -3 -42 -88 -92 -190 -90 -180 -93 -186 -78 -213 21 -37 61 -55 94 -42 21 7 50 57 151 260 69 137 125 256 125 264 0 8 -11 28 -24 43 l-24 28 -164 3 c-122 1 -171 -1 -194 -12z" fill="var(--banner-text-color)"/>
									<path d="M2764 3910 c-26 -10 -54 -48 -54 -71 0 -9 9 -28 21 -43 20 -25 24 -26 125 -26 63 0 104 -4 104 -10 0 -6 -38 -87 -85 -180 -47 -94 -85 -182 -85 -198 0 -52 63 -86 106 -58 27 18 264 481 264 517 0 33 -17 56 -51 68 -37 13 -314 14 -345 1z" fill="var(--banner-text-color)"/>
									<path d="M1358 2321 c-89 -29 -151 -107 -152 -193 -1 -41 3 -53 23 -69 13 -10 33 -19 46 -19 32 0 75 37 75 64 0 33 37 76 65 76 27 0 65 -42 65 -72 0 -27 45 -68 75 -68 15 0 37 11 52 26 22 23 25 31 19 71 -9 65 -48 128 -100 158 -48 28 -125 40 -168 26z" fill="var(--banner-text-color)"/>
									<path d="M2582 2317 c-82 -30 -141 -111 -142 -194 0 -33 5 -46 26 -62 52 -41 110 -17 120 50 8 50 43 77 81 63 28 -10 39 -25 48 -66 7 -34 42 -68 71 -68 12 0 33 9 48 21 21 17 26 29 26 65 0 136 -148 238 -278 191z" fill="var(--white)"/>
									<path d="M1835 2005 c-32 -31 -32 -66 1 -105 72 -84 209 -109 316 -57 32 16 67 40 78 54 29 37 26 87 -6 112 -35 27 -54 26 -95 -4 -75 -55 -120 -56 -184 -5 -46 36 -78 38 -110 5z" fill="var(--white)"/>
								</g>
							</svg>
						<!-- <img
							:src="reward.type === 'freebet' ? '/assets/images/receipt.svg' : '/assets/images/mission_slot.svg'"
							:style="reward.type === 'freebet' ? 'width: 60px; height: 65px;' : 'width: 70px; height: 65px;'"
							alt=""
						/> -->
						<template v-if="reward.dynamic">
							<div style="display: flex; flex-direction: column; align-items: center;">
								<Popper arrow hover openDelay="100" closeDelay="100" placement="bottom">
									<div style="display: flex; align-items: center; gap: 5px; cursor: help;">
										<p style="color: var(--banner-text-color); margin: 0;">{{ $t('missions.dynamic') }}</p>
										<img src="/assets/images/info-icon.svg" alt="info" style="filter: brightness(0) saturate(100%) invert(84%) sepia(28%) saturate(287%) hue-rotate(57deg) brightness(95%) contrast(92%);" />
									</div>
										<template #content>
											<div class="tooltip">
												{{ reward.type === 'freebet' ? $t('missions.the_freebet_reward_is_dynamic') : $t('missions.the_freespin_reward_is_dynamic') }}
											</div>
										</template>
								</Popper>
							</div>
						</template>

						<template v-else>
							<h2 style="margin: 0; font-size: 1.5rem;">
								{{ reward.amount }} <span v-if="reward.type === 'freebet'">{{ currencyStore.getCurrencySymbol }}</span>
							</h2>
							<p style="color: var(--banner-text-color);">
								{{ reward.type === 'freebet' ? $t('betslip.freebet') : $t('general.freespins') }}
							</p>
						</template>
					</div>
				</div>
			</div>
		</div>

		<div class="button_position">
			<div class="button_container">
				<button class="btn-small btn-secondary" style="width: 120px;" @click="selectMission(props.mission.id)">{{ $t('missions.learn_more') }}</button>
			</div>
		</div>
	</div>
</template>
<style scoped>
.tooltip {
	width: 130px;
	background-color: var(--primary);
	padding: 5px 0;
	text-align: center;
	border: 1px solid var(--primary);
	border-radius: 10px !important;
	font-size: 10px;
	color: var(--scoreboard-text-color);
}
:deep(.popper) {
	background-color: var(--primary);
	padding: 20px;
	border-radius: 20px;
	font-weight: bold;
	margin-right: 30px;
}

:deep(.popper #arrow::before) {
	background: var(--primary);
	left: 0px;
}
:deep(.popper:hover),
:deep(.popper:hover > #arrow::before) {
	background: var(--primary);
}
.title {
	display: grid;
	grid-template-columns: 24px 1fr 24px;
	align-items: center;
	gap: 10px;
	padding: 10px;
}
.title img {
	width: 24px;
}
.title h6 {
	color: var(--banner-text-color);
	margin-top: -2px;
}
.background {
	background-image: url('../../../../public/assets/images/missions_background.jpg');
	background-size: contain;
	background-repeat: no-repeat;
	min-height: 535px;
	min-width: 320px;
}
.title_container {
	padding-top: 10%;
	text-align: center;
	color: var(--banner-text-color);
}
.subtitle_container {
	text-align: center;
	color: var(--banner-text-color);
	margin-top: 5%;
}

.item {
	display:flex;
	justify-content: center;
	align-items: center;
	margin-top: 60px;
	flex-direction: column;
}
.item h2 {
	color: var(--secondary);
}

.button_position {
	position: absolute;
	bottom: 50px;
	width: 100%;
}

.button_container {
	display: flex;
	justify-content: center;
}
</style>